import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';

import { title as pageTitle } from '@/state/layout/header';

export default function (title: string) {
    const setTitle = useSetRecoilState(pageTitle);
    useEffect(() => {
        setTitle(title);
    }, []);
}
